import { notify } from "node-notifier";

var CryptoJS = require("crypto-js");

var _nothing = "U2FsdGVkX18MFTltJRvcNHsO+FkLVvqtWyX1DunXzPMj3q8zKN/kGd1PMocXameIuBNBquvCKFZjtFZZ8mykdlWPaU64gzLqMl7uyi53b7HRbjPL6GwlN2u+mfRQxh1W6BXVHBcW8eY/AeYStIewAl9WQLxBR+jrK+D6VqkiSwVz2Ls7rXx6aA/2lUpoHBHQ"

var _state = {
    cur: 0,
    resume: _nothing,
    key: ""
}
const _util = {
    getToday () {
        var year = new Date().getFullYear(), month = new Date().getMonth() + 1;
        return `${year}年${month}月`
    },
    decode (crypto_content) {
        try {
            return CryptoJS.AES.decrypt(crypto_content, _state.key).toString(CryptoJS.enc.Utf8);
        } catch (e) {
            if("Malformed UTF-8 data" === e.message)
               return console.log("%c 密码错误.", "color: red")
            throw e
        }
    },
    updateResume(time, idx) {
        _state.resume = _resumes[idx].detail || _nothing;
    },
    setKey(key) {
        _state.key = key;
        _state.resume = _nothing = _util.decode(_nothing)
        _util.test()
        var l = _resumes.length - 1;
        for (let i = l; i; i--) {
            ["time", "detail", "content"].forEach(k => {
                _resumes[i][k] = _util.decode(_resumes[i][k])
            })
            _resumes[i].tags = _resumes[i].tags.map(_util.decode);
        }
    },
    test() {
        window.cry = function (text) {
            return CryptoJS.AES.encrypt(text, "your key").toString()
        }
        window.rep = function (str) {
            return str.replace(/\"(?:[^\"])*\"/g, a => '"' + window.cry(a.slice(1, -1)) + '"')
        }
        window.dec = function (txt) {
            return _this.decode(txt)
        }
        console.log("%c test: == :", "color:#00a45d;");
    }
}
var _resumes = [
    { time: _util.getToday(), content: '' },
    {
        time: "U2FsdGVkX1/o+xb1hPOTAYyQtnOjNisdLmw5P8j+QfI=",
        content: "U2FsdGVkX1+xfImiMCm4nFyHcxm7LhaCFSrUD07tPsCpVViKfFxJspnnoK+H4BOjeBlKIGf1atmfz30w0CLmwQ==",
        detail: "U2FsdGVkX1/rwCWLJ5br6p0KB0/9wsnGu4R+lhSO7FtURBU8iA/OpZkfTGiiE8Aj0rRPWwkIAY0ZuZlo3LODmgL2cdwc9RotXD4hE1BHfdSjXDKcQddaU8CSxJAhQcWvRUsiu+RMuY3vxiwnvBv3FjvwEi9bpZp5Ue7Vt7JGxLPU56bELp+pCSY3JydotpbBR/mJyPsGB69veUaay1hhdvvjwMxacyt5nx9JtA22f8qePEJK61h2ddiRo3JYmCjAMbqNuHsjo1IsmSyxCFvLXqrHz5MGNS2k0VPRqbbhLGBLu8d50I91XLFo6YeN0rsexIW3M2VDt73vvQauy2nygmybu9nLWY3Jko8h/ivrHJTgKEcY4lmbBvN67sIKQQDPhgkPv9RoakyfeBam1Z3D4wBofdcsPp4qSKfxHwK3/Qvxr8OV84n+jTUcfBlnCeoiKE5Iaov4hu4MjVuv45yvk6Rn1+9Pzreqq3aMFWmCwpC29Np0aDRyPRDrDh4dePfvNCzrhGfJ06cpoUwxUjJOuGgi7JRwdh/IGwrOARWjPHmlKfpsiaSOpndQodSaF9HNzNbb7NlpfT532ocz+M1sE5dKnt6GdbAX0i9RStb1tI9gvR0xS7qRqvR5BFSD3Ubf7CaQcwWC33JcYC7NZHEL7vczzqCX7yfs0L/s2xGdlVAq285plWMqzswlMbIw0tavTOSbWp9J5mjmQ1a+SOq5bHBHJ5qvSKawUS7K9PDNHgodJIMZ6yUi9cMJ/jtgVXwh",
        tags: ["U2FsdGVkX1/gOE6EEUCfoAZfRPYEnUgO4tdhQ0g2Fso=", "U2FsdGVkX18pcQzEIJyRi2wsk0jvtB59xEkm3qqatbo=", "U2FsdGVkX19CJ2oZQhjAsIbxNRi6Up2HMwPH41/EN5M=", "U2FsdGVkX18sgciU7fvb6j0+ZtRpY/kiYmLW8UZoI4A=", "U2FsdGVkX18l8q5pRcdlS+f1a46YHwXllmgL7jwaJOg=", "U2FsdGVkX19ZBLE5Hk0hvb+3kWbllw27hOEQ4ocoUiY="]
    },
    {
        time: "U2FsdGVkX18xR13aOnleZUEbLR5xm7cH6VdDwmM3TQs=",
        content: "U2FsdGVkX1/1wmujxABPBjXDvHuAsetXUrLIg6vbxAnPNjXnQjGtfFNzNZhc7D21",
        detail: "U2FsdGVkX1+UI3IEZnrnNHjh+4EcLzjEh8DY9ld1n2WmdIwKVNLwhCo0p1T9RI5KrIsOSJopH6I9v0NxiXUuYLUgRKRt/nZSaP7SvTQNgqZ8yraagvC/0F/RPii3CoPvnr+IONzTn1rMBqyguMkcKx0HSu3A8b4k7KSVwncHSzZ8kYbN1Yn5190DoeajjDyVaeas6tdNUPuCWetBrg9dOjm+qoUc3lxuIjU9IaUArJkRdj9EB9dgqGUes04W/kG/4poflL+nIlKufEMdRI+so0BXPoG+aSg0eenh1gOvRzQDvxE74zMl5nfUoQ995N0am3CJJhAKvxSJFv9AcX2v3TOXLlanVMSVQCNNQd6TEu2/avu66at792bVOtRekDWGcUkRO0Bedo4QOmo1rc+nK4wtF4QY3NW+AlTfwqNBAuQT6DOAWPuOgThfOZXdPAG/A0WW+R9wBGzzj2p0ljJbIUh3fgfPQidXM+n9IM7LNkwJvsWHpeNeP2JvmQlo1rNvJPfrsoKcrM0IuXZr0Tdcxl/u6849ISslQECiAl6NJB5iwELFXc6c86vRKoUM6GDagB0rwLKvc4poJe3MqB7UWMecKLUU7W6gD/CFx9tQo3HRjHsI0xdbki+IZrUEM1sokbE6NW9sPuqgjb0pb1pcR0IQ0N8DoRa7ITZUYSnTCueyown8b3sKPLy2LBALccxMzIRgOt5bUmE2+WfmmEeEOZUXnFTURDSnW+8PtUCl+4oNfij7cxMidr3QFzZVGtMi4tiHQlHGqdQSAF7L178VmPsvRMfskule880fBMWdJh5K+HtmXQWkoV/PmPcn+Te8pTy8UiYuFFGuBzyfnD6Zq0crILa5sa0JrGqcA2k0dCJhtdvY7o5bGNuoLRuuGA7qN7ZkOTGSbzxrqHSNuCxXsHY2sKYDbJ2qMObIgQnR68L0aNdSCTlktriSthsBo4h21WFcaKT4bC2Xh6JGXNptFMW/p2kB50PVEy06S/hHqGVEtMaj0N0gG3PYDvs8mNlk",
        tags: ["U2FsdGVkX1/Zyad46Ngrw2nD3+CVym5y1tCHbYb5ac4=", "U2FsdGVkX1/ZNhcalktBL6a3PNh48AubMI1uuoBEg10=", "U2FsdGVkX18WbvDfP37XZcrS6SdJOMrlNmXO6ocAmIc=", "U2FsdGVkX19IYhuXiEmNkPNDDvlU9IwWf6QNSwVuqYg=", "U2FsdGVkX18RlCPWJ8nlqx4dDhwjCgV//X//ncZOMYc="]
    },
    {
        time: "U2FsdGVkX1+f/7J87BJZLd24chKFlrImQzYm3aE4f5U=",
        content: "U2FsdGVkX18v7VNUJywtl/K9ufBVq5Nm7404zD9IOj1gKI39KviNGAC9APGI6wEWfcnPl/P+58iSI6JD4Uhfvw==",
        detail: "U2FsdGVkX1/aFtc1fCNTVkPpUtkqW1JmSuAaR+PZluASKACXHLmdXl+lnlPwC8f2bA0/P6OC69dGp8g30Vj4HN6fwFan0uzBWUXE1oe2T+5vzXuE4dd/Pu6Hi08K5NlAjl/9SzxGcBkHBdHj3owSmQiDqIu3wv9Z4Au297hZFxLLGmOs9rlIM9me3NbIA/kN39/d+BcS04gPC3mywHHp55MmZy+WntdlOSMDJ0g67cEUgzJbDcMDxA40KUaoDQgIL0Mb1mtUKUtx9YeYGsZ1iIPrT49QfSAq7qkrbywiRpyGPR79b1oOigzrtYBqnbHMr8s4q4tdKvBvlFB2sCH6N0IFlQrz3RbuzyfqHIxMWme1X2JzRMRtSF6zGsnzwPLN+qLb21t27MLwyagMi+t37agVIzXuwxBjCzt5PqoDbRwLTH1RuH5ijJDyW4AxN9FN4fcLTTQMaCD0EyA0PCPGB0F1vFTI0mLADYi9e8QgqpHebdugRg5zOYmEFpR9npO3dgW7rdd+e/QNvbtjeuMcvjSVuhkhOjR3tebFh10boVPy85l2ki/1GpkNtAWUxY//tH/ZnyYXHNX53onMHVMdVDxknafJJV0lpQkciI/wNyG24aW06q2U5wy7OEoZTPAAUaMx8RF8Fy9C4sCNlA04pH1iRe3/4bGGr3NUzrvM1ECcm2wh/zoPJc2ZsfeKfSYBujbVAzUGef1y+IPt9MjMPpjySDSlNV+4CuHURynBreuHDhilqVUjLPH6XbQ+qrJ7OKh9Mp3S678eX9vgSPJId47Bo6Ezer/iP3ElC7fHPam/i+wf1+/u5C2juZYkq/zCU/MNFUaWZO7HhN7gG6pw7G/fQLN3zMc6cDlsKBzwS9TndVVM83dgoodBssRxp62buSSU8V10n6AV99vlD/0PWB0r2hVbM7JlGIuqrYAq/I4pGruoYO/K1fBIh+D7O7qbVhF3rUyZNtfQ7n8wzZ1hEYeinFyShCii14PKVQZ7b4U3+xpbZTTWal9zj5tKNzhoQCFyGYXa/yO54HPsLE3bOw==",
        tags: ["U2FsdGVkX1+h9YQ0C5Vd4DVyylbl9+YSNTleVURAPeM=", "U2FsdGVkX1/XWop6o94W9ai1ZMctJ0OvOlKWIzlifI5yoYi1aDbbzeOei21In8OW", "U2FsdGVkX1+W4c0AAsBb3ZfBHhgW0d72L03MLKmV65A=", "U2FsdGVkX18Pgr4u/ZH8pwWGQQIfVbmxMDJA3j8lWJw="]
    },
    {
        time: "U2FsdGVkX19w+nyI/4K5pp75+cEo1VKIr/EHEmZawTQ=",
        content: "U2FsdGVkX18TmF8zpSpLBraGbPwvYjD5v11tm6V9/U3lfDk/CgwjRwXodeXO5XPZjg7+ffC2ehglYdwl1W41+A==",
        detail: "U2FsdGVkX184ztv/irqWNHjp0AVAydzg9PU48AXedAVMcJZ/DtwAWNM6z1ALHY7JFgbOqWHwrN8Fijq1qQUvLs4yrIUX3jtGa+krMiHQPvhLC0p50u6j6078SY6ICXF+EYA9L4NwTmA5+kq3R2APkVISz85bVnw1NE28u40lafjXj4y81SkkwpQodd3mMG+S+MvH3ffU74muIXAbigsUlj7oVQPftHXpL7nOvGNm9ytGiV/79r2QWh2e/aEhvYsuCrry5ro3qPC2UwSvgRc+RYoxkK7KSMarp0rTCng1kw3pHAJeAIdciOGAFDw8+nRyz5+qAjYWVRl2fs45ipkmHdTidlrQspws0YfAuy8jOgfHpqbLCKyt6cTPG/pGrCp7ENzuW4fCfNRgnVTPWkFEvs4erSZ0NE4bQfdjlMYVzZS9iXaipCQA0QWB46TxS9LM+m+TPiYZyzrNbSITD5kZgED7i6JVNDH8qgj00Vrg3ds=",
        tags: ["U2FsdGVkX1+JXY37AuwYrFHwVt2qAIheS+R9CWUsPnI=", "U2FsdGVkX18mBC+wQ/6GnWEo07/S4smW0FZTAsBMvrU=", "U2FsdGVkX1/VfGnv98ZqM8TJ00lBXSi6JUG+q5t2dx8=", "U2FsdGVkX18v3bgKx215HlqcqnP4h7ydq3pzfHyOQDQ="]
    }
]
export default {
    state: _state,
    resumes: _resumes,
    setKey: _util.setKey,
    decode: _util.decode,
    updateResume: _util.updateResume
}


// WEBPACK FOOTER //
// ./src/common/store.js